import React from 'react';

export class ProductStylitics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id='dds-stylitics-widget'>
        <h2 className='relative' id='dds-stylitics-widget-title' style={{ display: 'none' }}>
          <span>How to Style It</span>
        </h2>
        <div id='dds-stylitics-widget-container'></div>
        <div
          className='stylitics-qv hidden'
          data-modal-body='QuickView'
          data-modal-title='Quick View'
          data-target='.modal-quickview'
          data-toggle='modal'
        ></div>
      </div>
    );
  }
}

export default ProductStylitics;
